// import EditIcon from "@mui/icons-material/Edit";
import { Box, Typography } from "@mui/material";
import { KeyboardEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as EditIcon } from "../../common/icons/edit.svg";
import OrderRowCounter from "./OrderRowCounter";
import {
  OrdersHeaderButton,
  OrdersHeaderTextField,
  OrdersHeaderTitle,
  OrdersOrderNameContainer,
} from "./styles";
import theme from "../../theme";

type Props = {
  title: string;
  handleOrderTitleChange?: (title: string) => void;
  dateInformation?: string;
  timeInformation?: string;
  customerCompany: string;
  orderRowCount: number;
};

const OrdersHeader = ({
  title,
  handleOrderTitleChange,
  dateInformation,
  timeInformation,
  customerCompany,
  orderRowCount,
}: Props) => {
  const [isEditing, setIsEditing] = useState(false);

  const { t } = useTranslation("order");

  const handleIsEditingOnEnter = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e?.key === "Enter" && title.trim() && isEditing)
      return setIsEditing(false);
  };

  return (
    <Box
      sx={{
        padding: "0 8px",
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "20px",
      }}
    >
      <Box>
        <Typography
          variant="header"
          sx={{
            minHeight: "24px",
            fontSize: "14px",
            fontWeight: 700,
            textTransform: "uppercase",
            marginBottom: "4px",
          }}
          color={theme.palette.primary.main}
        >
          {customerCompany}
        </Typography>
        <OrdersOrderNameContainer
          onClick={() =>
            handleOrderTitleChange !== undefined && setIsEditing(true)
          }
          onKeyDown={handleIsEditingOnEnter}
        >
          {isEditing ? (
            <OrdersHeaderTextField
              name="orderName"
              autoFocus
              autoComplete="off"
              variant="standard"
              value={title}
              onChange={(e) =>
                handleOrderTitleChange && handleOrderTitleChange(e.target.value)
              }
              onBlur={() => {
                setIsEditing(false);
                if (!title.trim() && handleOrderTitleChange)
                  handleOrderTitleChange(t("order:newOrder"));
              }}
              inputProps={{ style: { height: "40px" } }}
            />
          ) : (
            <OrdersHeaderTitle variant="header">
              {title || t("order:newOrder")}
            </OrdersHeaderTitle>
          )}
          {handleOrderTitleChange === undefined ? (
            <>
              <Typography sx={{ marginLeft: 1 }}>{dateInformation}</Typography>
              <Typography sx={{ marginLeft: 1 }}>{timeInformation}</Typography>
            </>
          ) : (
            <OrdersHeaderButton startIcon={<EditIcon />}>
              {t("renameOrder")}
            </OrdersHeaderButton>
          )}
        </OrdersOrderNameContainer>
      </Box>
      <Box hidden={handleOrderTitleChange === undefined}>
        <OrderRowCounter
          orderRowCount={orderRowCount}
          sx={{
            boxSxProps: {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "48px",
              height: "48px",
              backgroundColor: "#F3F3F7",
              borderRadius: "100%",
            },
            textSxProps: {
              fontSize: "26px",
              fontWeight: 600,
              color: "rgba(0, 0, 0, 0.52)",
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default OrdersHeader;
